/*
 * @Author: your name
 * @Date: 2022-03-02 09:37:28
 * @LastEditTime: 2024-06-13 15:36:56
 * @LastEditors: bobo 350910378@qq.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \baishu_react_ui\src\components\BsyCheckBox\index.jsx
 */
import React, { Component } from "react";
import { BsyWidget } from "../BsyWidget";
import "./index.css";

class BsyCheckBox extends BsyWidget {
  static defaultProps = {
    text: "",
    value: false,
  };
  constructor(props) {
    super({
      baseCls: "BsyCheckBox",
      ...props,
    });
    this.state = {
      text: this.options.text,
      value: this.options.value,
    };
  }

  setValue = (value) => {
    this.setState({
      value: value ? true : false,
    });
  };
  // static getDerivedStateFromProps(nextProps, prevState) {
  //   console.log("2. getDerivedStateFromProps", nextProps, prevState);
  //   const { value } = nextProps;

  //   if (value !== prevState.value) {
  //     //   console.log("更新");
  //     return {
  //       value,
  //     };
  //   }
  //   // console.log("未更新");
  //   return null;
  // }
  getValue = (value) => {
    return this.state.value;
  };
  checkChange = (val) => {
    return (event) => {
      event.stopPropagation();
      event.preventDefault();
      this.setState(
        {
          value: val,
        },
        () => {
          if (this.props.onChange) {
            this.props.onChange(val);
          } else if (this.props.onStopEdit) {
            this.props.onStopEdit(val);
          }
        }
      );
    };
  };
  render() {
    const { text, value } = this.state;
    const { cssName } = this.options;
    return (
      <div
        className={cssName}
        onClick={this.checkChange(!value)}
        ref={this.element}
      >
        {
          <div
            className={
              "x-item-check data-label-type " + (value ? "select" : "")
            }
          >
            <i className="icon-blank" />
            {text && <span>{text}</span>}
          </div>
        }
      </div>
    );
  }
}

export default BsyCheckBox;
